import {
  AccountApproverEntry,
  AutoApprovalConfigResponse,
  ItemApiEditApproversRequest,
  ItemApiGetAutoApprovalConfigurationRequest,
  ItemApiListAccountApproversRequest,
  ItemApiSaveAutoApprovalConfigurationRequest,
} from '@ariksa/jit/api';
import { QueryContext } from 'services/utils/QueryContext';
import { takeLatestAction } from 'services/utils/takeLatestAction';

import { authOptions } from 'api/auth';
import {
  UserService,
  UserServiceListRequest,
  UserServiceListResponse,
} from 'api/auth/api.pb';
import { JitService } from 'api/services';

import { actions } from './slice';

export function* jitSaga() {
  yield takeLatestAction(actions.getApprovers, doGetApprovers);
  yield takeLatestAction(actions.editApprovers, doEditApprovers);
  // Lives here rather than in the Setup saga: the approvers modal is shared
  // with the data-group screens, which never inject that one.
  yield takeLatestAction(actions.getJitUsers, doGetJitUsers);
  yield takeLatestAction(
    actions.getAutoApprovalConfiguration,
    doGetAutoApprovalConfiguration,
  );
  yield takeLatestAction(
    actions.saveAutoApprovalConfiguration,
    doSaveAutoApprovalConfiguration,
  );
}

export function* doGetApprovers(
  ctx: QueryContext<AccountApproverEntry[], ItemApiListAccountApproversRequest>,
) {
  yield ctx.fetch(() => JitService.Jit.listAccountApprovers(ctx.params));
}

export function* doEditApprovers(
  ctx: QueryContext<any, ItemApiEditApproversRequest>,
) {
  yield ctx.fetch(() => JitService.Jit.editApprovers(ctx.params));
}

export function* doGetJitUsers(
  ctx: QueryContext<UserServiceListResponse, UserServiceListRequest>,
) {
  yield ctx.fetch(async () => {
    const r = await UserService.List(ctx.params, authOptions());
    return { data: r };
  });
}

export function* doGetAutoApprovalConfiguration(
  ctx: QueryContext<
    AutoApprovalConfigResponse,
    ItemApiGetAutoApprovalConfigurationRequest
  >,
) {
  yield ctx.fetch(() =>
    JitService.Jit.getAutoApprovalConfiguration(ctx.params),
  );
}

export function* doSaveAutoApprovalConfiguration(
  ctx: QueryContext<
    AutoApprovalConfigResponse,
    ItemApiSaveAutoApprovalConfigurationRequest
  >,
) {
  yield ctx.fetch(() =>
    JitService.Jit.saveAutoApprovalConfiguration(ctx.params),
  );
}
